import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HairPage from "./pages/HairPage";
import IngredientDetailPage from "./pages/IngredientDetailPage";
import ComparePage from "./pages/ComparePage";
import HomePage from "./pages/HomePage";
import MainLayout from "./MainLayout";
import SelectOtherProducts from "./components/SelectOtherProducts";
import { CompareProvider } from "./CompareContext";
import MainPage from "./pages/MainPage";
import ScanPage from "./pages/ScanPage";
import PersonalizePage from "./pages/PersonalizePage";
import VitaminsDetailPage from "./pages/VitaminsDetailPage";
import ProductPage from "./pages/ProductPage";
import SupportPage from "./pages/SupportPage";

const App = () => {
  return (
    <CompareProvider>
      <Router>
        <Routes>
          <Route element={<MainLayout />}>
            <Route path="/support" element={<SupportPage />} />
            <Route path="/product/:barcodeOrId" element={<ProductPage />} />
            <Route path="/ingredient/:ingredient" element={<IngredientDetailPage />} />
            <Route path="/compare" element={<ComparePage />} />
            <Route path="/select-products" element={<SelectOtherProducts />} />
            <Route path="/food" element={<MainPage />} />
            <Route path="/vitamin" element={<VitaminsDetailPage />} />
            <Route path="/scan" element={<ScanPage />} />
            <Route path="/personalize" element={<PersonalizePage />} />
            <Route path="/" element={<HomePage />} />
          </Route>
        </Routes>
      </Router>
    </CompareProvider>
  );
};

export default App;
